import { LocalStorageAccessCheckInKeys } from "../models";

export const setNoShowAgainCheckOutModal = (checked: boolean) => {
  checked && (
    localStorage.setItem(
      LocalStorageAccessCheckInKeys.NO_SHOW_AGAIN_CHECK_OUT_MODAL,
      String(checked)
    )
  );
}